export default __webpack_public_path__ + "static/media/seshavaham.4063b353.png";